export default "__VITE_ASSET__CvSChCMg__"